export function getPropertyAddress(property) {
  const { zip, street, city, state } = property
  return `${street}, ${city}, ${state}, ${zip}`
}
